import { Stack } from "@mui/material"
import { ReactElement, useContext } from "react"

import CreateAcuDeviceProgressStepper from "./components/createAcuDeviceProgressStepper"
import AcuManufacturer from "./formPages/acuManufacturer"
import CoreAcuDeviceDetails from "./formPages/coreAcuDeviceDetails"
import ReviewAndSubmitAcuDevice from "./formPages/reviewAndSubmitAcuDevice"
import { CreateAcuDeviceContext } from "./providers/baseProviders/createAcuDeviceProvider"
import { Datasets } from "../../../../constants/enums"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"
import LctDeviceAttachments from "../../common/components/attachments/lctDeviceAttachments"
import { HpDeviceFormData } from "../types/providerTypes"

/** The form for creating an Air Conditioning Unit device */
const CreateAcuDeviceForm = (): ReactElement => {
    const { canEditManufacturer } = useContext(CreateAcuDeviceContext)

    return (
        <Stack spacing={GRID_SPACING}>
            <AppCard>
                <AppCardContent>
                    <CreateAcuDeviceProgressStepper />
                </AppCardContent>
            </AppCard>
            <MultiPageForm context={CreateAcuDeviceContext}>
                {canEditManufacturer && (
                    <AcuManufacturer context={CreateAcuDeviceContext} />
                )}
                <CoreAcuDeviceDetails context={CreateAcuDeviceContext} />
                <LctDeviceAttachments<HpDeviceFormData>
                    context={CreateAcuDeviceContext}
                    dataset={Datasets.ACU}
                    isAmendment={false}
                />
                <ReviewAndSubmitAcuDevice
                    context={CreateAcuDeviceContext}
                    isAmendment={false}
                />
            </MultiPageForm>
        </Stack>
    )
}

export default CreateAcuDeviceForm
